import React from "react";
import { Breadcrumbs, Typography, Link, Button, Switch } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";

const pathNameMap = {
  "": "หน้าหลัก",
  buy: "รับซื้อ",
  create: "สร้าง",
  sale: "ขาย",
  customers: "รายชื่อซัพพลายเออร์",
  checkout: "จัดการรายการ",
  customer_group: "จัดการกลุ่มซัพพลายเออร์",
  ticket: "จัดการรายการ",
  edit: "แก้ไขข้อมูลซัพพลายเออร์",
  po_management: "จัดการใบเสนอราคา (PO)",
  so_management: "จัดการใบเสนอราคาขาย (SO)",
  po_create: "เปิดใบเสนอราคา (PO)",
  po_edit: "เปิดใบเสนอราคา (PO)",
  stock: "สต๊อกสินค้า",
  transform: "แปรสภาพ",
  exchange: "เริ่มแปรสถาพ",
  inventory: "คลังสินค้า",
  reports: "รายงาน",
  purchases: "ยอดซื้อ",
  sales: "ยอดขาย",
  daily_purchases: "สรุปยอดซื้อประจำวัน",
  lock_pricing: "ล็อกราคาสินค้า",
  individual_purchases: "สรุปยอดซื้อสินค้ารายบุคคล",
  summary_purchases_product: "สรุปยอดซื้อสินค้ารายชนิด",
  summary_ticket_purchases: "สรุปยอดซื้อสินค้ารายBatch",
  cost_inventory: "ต้นทุนสินค้าคงเหลือ",
  daily_sales: "สรุปยอดขายประจำวัน",
  individual_sales: "สรุปยอดขายสินค้ารายบุคคล",
  summary_sales_product: "สรุปยอดขายสินค้ารายชนิด",
  summary_ticket_sales: "สรุปยอดขายสินค้ารายBatch",
  "sale-customers": "ซัพพลายเออร์ฝั่งขาย",
  edit_button: "จัดการปุ่มสินค้า",
  "qrcode-generate": "สร้างคิวอาร์โค้ด",
  "product-pricing": "แก้ไขราคาสินค้า",
  top_monthly_purchases: "10 อันดับ ยอดซื้อรายบุคคลประจำเดือน",
  top_monthly_sales: "10 อันดับ ยอดขายรายบุคคลประจำเดือน",
  monthly_purchases : "รายงานยอดซื้อรายเดือน",
  monthly_withdrawl: "รายงานยอดขายรายเดือน"
};

const ticketStatus = {
  waiting: "รอจ่าย",
  sent: "ส่งแล้ว",
  confirm: "ยืนยันแล้ว",
  payed: "จ่ายแล้ว",
  cancel: "ยกเลิก",
};

export default function AppBreadcrumbs() {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const searchParams = new URLSearchParams(location.search);
  const poId = searchParams.get("id");
  const status = searchParams.get("status");
  const ticket = searchParams.get("ticket");
  const breadcrumbs = [];

  for (let i = 0; i < pathnames.length; i++) {
    const segment = pathnames[i];
    const to = `/${pathnames.slice(0, i + 1).join("/")}`;
    let label = pathNameMap[segment] || segment;
    if (segment === "po_edit" && poId) {
      const poNumber = poId.padStart(4, "0");
      label = `เปิดใบเสนอราคา (PO #${poNumber})`;
      breadcrumbs.push({ label, to, isLast: true });
      break;
    } else if (segment === "ticket" && status) {
      const statusMap = {
        waiting: "รอจ่าย",
        sent: "ส่งแล้ว",
        confirm: "ยืนยันแล้ว",
        payed: "จ่ายแล้ว",
        cancel: "ยกเลิก",
      };
      const displayStatus = statusMap[status] || status;
      label = `รายการBatch (${displayStatus})`;
      breadcrumbs.push({ label, to, isLast: true });
      break;
    } else if (segment === "checkout" && ticket) {
      const parts = ticket.split("-");
      const result = parts[parts.length - 1];

      // 🔙 เพิ่ม breadcrumb "กลับ"
      breadcrumbs.push({
        label: `รายการ (${ticketStatus[status]})`,
        to: "back",
        isLast: false,
      });

      label = `จัดการรายการ #${result}`;
      breadcrumbs.push({ label, to, isLast: true });
      break;
    }

    breadcrumbs.push({ label, to, isLast: i === pathnames.length - 1 });
  }
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ backgroundColor: "#f5f5f5", p: 2, borderRadius: 2 }}
    >
      <Link
        underline="none"
        color="inherit"
        onClick={() => navigate("/")}
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      >
        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        หน้าหลัก
      </Link>
      {breadcrumbs.map(({ label, to, isLast }) =>
        isLast ? (
          <Typography key={to} color="text.primary">
            {label}
          </Typography>
        ) : (
          <Button
            key={to}
            variant="contained"
            onClick={() => {
              if (to === "back") {
                navigate(`/${pathnames[0]}/ticket?status=${status}`);
              } else {
                navigate(to);
              }
            }}
            sx={{ textTransform: "none", borderRadius: 4 }}
            color="success"
          >
            {label}
          </Button>
        )
      )}
    </Breadcrumbs>
  );
}
